// import _ from 'lodash'
import {
  READ_PROJECTS,
  RESET_PROJECTS,
  // CREATE_PROJECT,
  // UPDATE_PROJECT,
  // DELETE_PROJECT
} from "../actions";

const projects = (state = [], action) => {
  switch (action.type) {
    case READ_PROJECTS:
      return action.response.success.projects;
    // return state
    // case CREATE_PROJECT:
    //   return state
    // case UPDATE_PROJECT:
    //   return state
    // case DELETE_PROJECT:
    //   return state
    case RESET_PROJECTS:
      return [];
    default:
      return state;
  }
};

export default projects;
